import { useMetaAudienceStore } from "@/stores/MetaAudienceStore";

export const MetaAudienceStores = [useMetaAudienceStore];

export const MetaAudienceChannel = {
  received(payload) {
    // Export completion (success or error) is handled by the shared export
    // manager, which downloads the standardized `payload.data.files`.
    this.metaAudienceStore.handleExportMessage(payload);

    const match = Object.values(this.metaAudienceStore.summaryCounts).find(
      (task) => task.task_id === payload.id,
    );
    if (match) {
      match.loading = false;
      match.task_id = undefined;
      if (payload.status !== "error") {
        match.count = payload.data?.count;
      }
    }
  },
};
